<div class="modal-header container-fluid ab-modal__header" tabindex="0">
  <div class="ab-modal__close">
    <button
      class="btn btn--link-color btn--no-shadow"
      type="button"
      (click)="activeModal.dismiss()"
    >
      <i class="glyphicon glyphicon--45-deg glyphicon-ab-plus"></i>
      &nbsp;<span class="ab-modal__close__text">Close</span>
    </button>
  </div>
</div>
<div class="modal-body container-fluid ab-modal__body">
  <div class="row mb-3 text-center">
    <div *ngIf="!sendingData" class="col-md-12">
      <h4 class="ab-modal__subtitle">
        Hey! Here's a starter project for you. Want to see some data in action?
        Click the button, and we will start populating this dashboard with some
        cool data
      </h4>
      <div class="text-center">
        <a class="btn btn--primary" (click)="sendData()">Send Data</a>
      </div>
    </div>
    <div *ngIf="sendingData" class="col-md-12">
      <h4 class="ab-modal__subtitle">
        Error and APM data will begin to populate in a few minutes and will
        continue to accumulate inside your first project over the next 7 days.
      </h4>
    </div>
  </div>
</div>
